<template>
    <div>
      <div v-for="(item, index) in permissions" :key="index">
          <div class="permission-row">
              <el-select :disabled="disabledPermissions" v-model="item.presetId" :placeholder="$t('users_tab_permissions_first_select_presset')" size="mini">
                  <el-option disabled label="Fixed Permissions" value="1"></el-option>

                  <el-option
                          v-for="presset in pressetsList"
                          v-show="presset.isDefault"
                          :key="presset.id"
                          :label="$t(presset.permissionPressetName)"
                          :value="presset.id"
                          @click.native="onSelectionChanged(presset, item)">
                  </el-option>

                  <el-option disabled label="Created Permissions" value="2"></el-option>

                  <el-option
                          v-for="presset in pressetsList"
                          v-show="!presset.isDefault"
                          :key="presset.id + 1000"
                          :label="$t(presset.permissionPressetName)"
                          :value="presset.id"
                          @click.native="onSelectionChanged(presset, item)">
                  </el-option>
              </el-select>
          </div>
          <div class="permission-row">
              <el-checkbox-group :disabled="disabledPermissions" v-model="item.permissionsIdArr">
                  <div v-for="(permissions, index) in permissionsList" :key="index" class="permissions">
                    <div class="permissions__title">{{$t(permissions.permissionFilterName)}}:</div>
                    <el-checkbox :disabled="disabledPermissions" v-for="(permission, index) in permissions.permissionList" @change="changePermission(item)" :label="permission.id" :key="index">{{$t(permission.permissionName)}}</el-checkbox>
                  </div>
              </el-checkbox-group>
          </div>
          <div class="permission-row">
              <el-button v-if="!disabledPermissions" :disabled="disabledPermissions" type="primary" plain size="mini" @click="saveUserPermissions(item)">{{$t('users_tab_document_first_save')}}</el-button>
          </div>
      </div>
    </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: "projectPermissionTab",
    props: [
      'userId',
      'permissions',
      'disabledPermissions',
      'activePermissionTab'
    ],
    computed: {
      user() {
        return this.$store.state.user
      },
      // permissions() {
      //   this.$store.getters.getProjectPermissionsList.forEach(val => {
      //     val.activePressetId = val.permissionPreset ? val.permissionPreset.id : 0
      //   });
      //   return this.$store.getters.getProjectPermissionsList
      // },
    },
    mounted(){

    },
    created() {

    },
    data() {
      return {
        permissionsList: [],
        pressetsList: [],
      }
    },
    methods: {
      getCompanyPresset() {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/permissionPressets/list?permissionGroup=1&companyId=${this.$route.query.companyId}`)
            .then(response => {
              console.log('---', response.data);
              const customPresset = {
                companyId: 0,
                id: 0,
                permissionGroup: 3,
                permissionPressetIdArr: [],
                permissionPressetName: "customPresset"
              };
              response.data.list.push(customPresset);
              this.pressetsList = response.data.list
              // resolve(response.data.list)
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/permissionRules/list?permissionGroup=1`)
            .then(response => {
              // console.log('---', response.data);
              // console.table(response.data.list)
              this.permissionsList = response.data.list

              // let list = {}
              // for (let i = 0; i < response.data.list.length; i++) {
              //   if (typeof(list[response.data.list[i].permissionFilterName]) === 'undefined') {
              //     list[response.data.list[i].groupIndex] = [];
              //   }
              //   list[response.data.list[i].permissionFilterName].push(response.data.list[i])
              // }
              // eslint-disable-next-line no-console
              // console.log('---', list)
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
      },
      getBusinessUnitPresset() {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/permissionPressets/list?permissionGroup=3&companyId=${this.$route.query.companyId}`)
            .then(response => {
              console.log('---', response.data);
              const customPresset = {
                companyId: 0,
                id: 0,
                permissionGroup: 3,
                permissionPressetIdArr: [],
                permissionPressetName: "customPresset"
              };
              response.data.list.push(customPresset);
              this.pressetsList = response.data.list;
              console.log('this.pressetsList', this.pressetsList)
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/permissionRules/list?permissionGroup=3`)
            .then(response => {
              console.log('---', response.data);
              this.permissionsList = response.data.list
              console.log('this.permissionsList', this.permissionsList)

              // let list = {}
              // for (let i = 0; i < response.data.list.length; i++) {
              //   if (typeof(list[response.data.list[i].permissionFilterName]) === 'undefined') {
              //     list[response.data.list[i].groupIndex] = [];
              //   }
              //   list[response.data.list[i].permissionFilterName].push(response.data.list[i])
              // }
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
      },
      getEngagementPresset() {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/permissionPressets/list?permissionGroup=4&companyId=${this.$route.query.companyId}`)
            .then(response => {
              console.log('---', response.data);
              const customPresset = {
                companyId: 0,
                id: 0,
                permissionGroup: 4,
                permissionPressetIdArr: [],
                permissionPressetName: "customPresset"
              };
              response.data.list.push(customPresset);
              this.pressetsList = response.data.list;
              console.log('this.pressetsList', this.pressetsList)
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/permissionRules/list?permissionGroup=4`)
            .then(response => {
              console.log('---', response.data);
              this.permissionsList = response.data.list
              console.log('this.permissionsList', this.permissionsList)

              // let list = {}
              // for (let i = 0; i < response.data.list.length; i++) {
              //   if (typeof(list[response.data.list[i].permissionFilterName]) === 'undefined') {
              //     list[response.data.list[i].groupIndex] = [];
              //   }
              //   list[response.data.list[i].permissionFilterName].push(response.data.list[i])
              // }
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
      },
      getProjectPresset() {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/permissionPressets/list?permissionGroup=2&companyId=${this.$route.query.companyId}`)
            .then(response => {
              console.log('---', response.data);
              const customPresset = {
                companyId: 0,
                id: 0,
                permissionGroup: 2,
                permissionPressetIdArr: [],
                permissionPressetName: "customPresset"
              };
              response.data.list.push(customPresset);
              this.pressetsList = response.data.list;
              console.log('this.pressetsList', this.pressetsList)
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/permissionRules/list?permissionGroup=2`)
            .then(response => {
              console.log('---', response.data);
              this.permissionsList = response.data.list
              console.log('this.permissionsList', this.permissionsList)

              // let list = {}
              // for (let i = 0; i < response.data.list.length; i++) {
              //   if (typeof(list[response.data.list[i].permissionFilterName]) === 'undefined') {
              //     list[response.data.list[i].groupIndex] = [];
              //   }
              //   list[response.data.list[i].permissionFilterName].push(response.data.list[i])
              // }
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
      },
      onSelectionChanged(presset, item) {
        item.permissionsIdArr = presset.permissionPressetIdArr
      },
      saveUserPermissions(item){
        let data = {}
        let url = ''
        switch (this.activePermissionTab) {
          case 'companyPermission':
            data = {
              userId: item.userId,
              companyId: item.companyId,
              pressetId: item.presetId,
              permissions: item.permissionsIdArr
            };
            url = `/api/v1/companyUsers/assignPermissions`
            break;
          case 'businessUnitPermission':
            data = {
              userId: item.userId,
              companyId: item.companyId,
              pressetId: item.presetId,
              businessUnitId: 0,
              permissions: item.permissionsIdArr
            };
            url = `/api/v1/businessUnits/user/assignPermissions`
            break;
          case 'engagementPermission':
            data = {
              userId: item.userId,
              companyId: item.companyId,
              pressetId: item.presetId,
              engagementId: 0,
              permissions: item.permissionsIdArr
            };
            url =  `/api/v1/engagement/user/assignPermissions`
            break;
          case 'projectPermission':
            data = {
              userId: item.userId,
              companyId: item.companyId,
              projectId: 0,
              pressetId: item.presetId,
              permissions: item.permissionsIdArr
            };
            url = `/api/v1/projects/user/assignPermissions`
            break;
        }
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(url, data)
          .then(response => {
            this.notification(this.$t('general_success'), this.$t('users_userPermissionSuccessfullyUpdated'), "success");
            if (this.user.user.id === item.user.id) {
              this.$store.dispatch('getCompanyLayout')
            }
            loader.hide();
          }).catch(error =>{
            loader.hide();
          console.log(error);
        })
      },
      changePermission(item){
        item.presetId = 0
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    }
  }
</script>

<style scoped lang="less">
    .permission-row{
        padding:10px;
    }

    .permissions {
      margin-bottom: 20px;
      &__title {
        font-size: 20px;
        margin-bottom: 5px;
        color: #B11A21;
      }
    }

    /deep/.el-checkbox-group {
      font-size: 16px;
    }

    /deep/.el-checkbox {
      margin-top: 10px;
      width: 200px;
      margin-right: 15px;
      white-space: normal !important;
      display: inline-flex;
      align-items: center;
      min-width: 200px;
    }
</style>
